import {TicketSetReadyToUseResultVo} from '../../common/shared/api/nicolas/vo/TicketSetReadyToUseResultVo.interface';
import {SetReadyToUseTicket} from '../generated/types';
import {createTicketInfo} from './TicketInfo';

export function createSetReadyToUseTicket({
  result: {my, purchase},
}: {
  result: TicketSetReadyToUseResultVo;
}): SetReadyToUseTicket {
  return {
    my: my && {
      hasOwnProduct: !!my.has_own_product,
      hasRentalProduct: !!my.has_rental_product,
      cashAmount: my.cash_amount,
    },
    purchase: purchase && {
      ...(purchase.ticket_own && {
        ticketOwn: createTicketInfo(purchase.ticket_own),
      }),
      ...(purchase.ticket_rental && {
        ticketRental: createTicketInfo(purchase.ticket_rental),
      }),
    },
  };
}
